import React from "react";
import brands from "../../data/brands";

/**
 * Franja de marcas con los logos oficiales. En mobile es un carrusel
 * horizontal con snap; de tablet para arriba, una grilla.
 *
 * Cada logo se limita por alto y por ancho para que convivan los apaisados
 * (Dompel, Hidracolor) con los cuadrados (Küül, Razorline).
 */
const BrandStrip = () => (
	<section id="marcas" className="anchor-target border-y border-line bg-white py-6 lg:py-8" aria-labelledby="brands-title">
		<div className="shell">
			<h2 id="brands-title" className="m-0 mb-5 text-[9px] font-extrabold uppercase tracking-eyebrow text-muted lg:mb-6">
				Nuestras marcas
			</h2>

			<ul
				className="m-0 flex list-none snap-x snap-proximity items-center gap-6 overflow-x-auto p-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:grid md:grid-cols-5 md:gap-y-7 md:overflow-visible lg:grid-cols-9 lg:gap-4"
			>
				{
					brands.map((brand) => (
						<li key={ brand.name } className="flex flex-none snap-start items-center justify-center px-2 md:flex-auto">
							<img
								src={ brand.logo }
								alt={ brand.name }
								loading="lazy"
								className="max-h-10 w-auto max-w-[104px] object-contain lg:max-h-11 lg:max-w-[120px]"
							/>
						</li>
					))
				}
			</ul>
		</div>
	</section>
);

export default BrandStrip;
